<template>
  <div>
    <div class="e2bp-layout" v-if="isAdmin">
      <div class="left">
        <h1>Excel a BP</h1>

        <div style="height: 16px"></div>

        <p>Sube un fichero BP Excel para generar un paquete de BPs</p>

        <v-form v-model="form">
          <FileInput :props="file_input_props" ref="file_input" />
          <v-btn color="primary" @click="submit_excel">
            Convertir
          </v-btn>
        </v-form>

        <div style="height: 32px"></div>

        <h2>Plantillas</h2>

        <v-progress-linear
          v-if="templates_loading"
          indeterminate
          color="primary"
        />

        <ul>
          <li v-for="temp, index in templates" :key="temp.name">
            <a @click="download_template(index)">
              <v-icon>mdi-download</v-icon>
              <span>{{ temp.name }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="right">

        <v-tabs v-model="tab">
          <v-tab key="documentation">Documentación</v-tab>
          <v-tab key="results">Resultados</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="documentation">
            <Excel2BPDocumentation />
          </v-tab-item>

          <v-tab-item key="results">

            <div
              v-if="loading"
              style="margin-top: 8px"
            >
              <v-progress-linear
                indeterminate
                color="primary"
              ></v-progress-linear>
              <div>
                Trabajando...
              </div>
            </div>

            <div v-else class="cont-results">

              <div>
                <a
                  :href="bppack ? bppack : '#'"
                  target="_blank"
                  @click="(ev) => {bppack || ev.preventDefault();}"
                >
                  <v-btn
                    color="primary"
                    :disabled="!bppack"
                  >
                    Descargar BP pack
                  </v-btn>
                </a>
              </div>

              <h2>Errores críticos en el Excel</h2>
              <div class="e2bp-out out-errors">
                <div v-if="errors.length <= 0" >
                  No hay errores
                </div>
                <div v-else>
                  <ul class="e2bp-console">
                    <li v-for="error, index in errors">
                      <span class="index">{{ index+1 }}</span>
                      <span class="text">{{ error }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <v-divider></v-divider>

              <h2>Avisos sobre posibles fallos en el Excel</h2>
              <div class="e2bp-out out-warnings">
                <div v-if="warnings.length <= 0" >
                  No hay avisos
                </div>
                <div v-else>
                  <ul class="e2bp-console">
                    <li v-for="warning, index in warnings">
                      <span class="index">{{ index+1 }}</span>
                      <span class="text">{{ warning }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <v-divider></v-divider>

              <h2>Reporte para desarrolladores</h2>
              <div class="e2bp-out out-report">
                <!-- TODO: Use a markdown library -->
                <pre style="overflow-x: scroll">{{ report }}</pre>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>

      </div>
    </div>

    <div v-else>
      <h1>Página reservada</h1>
      <p>No tienes permissos para ver este contenido</p>
    </div>
  </div>
</template>


<style lang="scss">
 @import "@/sass/variables.scss";

 .e2bp-layout {
   display: flex;
   flex-direction: row;
   flex-wrap: nowrap;
   padding: 18px;
   width: 100%;
   min-height: 90%;
   gap: 24px;
 }

 .e2bp-layout > .left {
   width: 20vw;
   min-width: 20vw;
   max-width: 20vw;
   border-style: solid;
   border-width: 0px 1px 0px 0px;
   border-color: #cacaca;
   padding-right: 16px;
 }

 .e2bp-layout > .right {
   width: 80vw;
   min-width: 60vw;
   max-width: 90vw;
 }

 .cont-results {
   padding-top: 16px;
 }

 .cont-results > h2 {
   margin-top: 12px;
   margin-bottom: 8px;
 }

 .e2bp-out {
   margin-bottom: 8px;
   padding-left: 16px;
 }

 .e2bp-console {
   display: flex;
   flex-direction: column;
   gap: 8px;
   margin: 0 !important;
   padding: 0 !important;
 }

 .e2bp-console > li {
   display: flex;
   flex-direction: row;
   flex-wrap: nowrap;
   margin: 0;
   padding: 0px;
   gap: 8px;
 }
 .e2bp-console > li > .index {
   display: block;
   min-width: 32px;
   width: 32px;
   text-align: right;
   color: #cc0000;
 }
</style>


<script>
 import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
 import { downloadFile } from '@/utils/browserfiles.js';
 import Excel2BPAPI from '@/api/Excel2BPAPI.js';
 import FileInput from '@/components/inputs/FileInput.vue';
 import Excel2BPDocumentation from '@/components/Excel2BPDocumentation.vue';

 export default {
   name: 'Excel2BP',

   components: {
     FileInput,
     Excel2BPDocumentation,
   },

   data: () => ({
     form: null,
     tab: null,
     loading: false,
     templates_loading: false,
     templates: [], // [["Name", "URL"]]
     file_input_props: {
       value: null,
       accept: '*.xlsx',
       placeholder: "BP Excel (xlsx)",
       label: "BP Excel"
     },
     errors: [],
     warnings: [],
     report: '', // Markdown text
     bppack: '', // URL to bppack
   }),

   computed: {
     ...mapGetters(['site_id', 'isAdmin']),
   },

   async mounted() {
     await this.query_templates();
   },

   methods: {
     show_results() {
       this.tab = 1;
     },

     verify_upload() {
       // TODO
       if (!this.$refs.file_input.value)
         return;
       return true;
     },

     async submit_excel() {
       console.log("submit_excel()");

       if (! this.verify_upload())
         return;

       let response = {};
       const formdata = new FormData();
       const file_input = this.$refs.file_input.value;
       formdata.append('excel', file_input);

       this.loading = true;
       this.show_results();
       try {
         response = await Excel2BPAPI.convert(this.site_id, formdata);
       } catch (err) {
         this.errors = [''+err];
       }

       this.parse_response(response);

       this.loading = false;
     },

     parse_response(response) {
       this.errors   = response.errors;
       this.warnings = response.warnings;
       this.report   = response.report;
       this.bppack   = response.url;
     },

     async query_templates() {
       this.templates_loading = true;
       const templates = await Excel2BPAPI.list_templates(this.site_id);
       this.templates = templates;
       this.templates_loading = false;
     },

     async download_template(index) {
       const temp = this.templates[index];
       this.templates_loading = true;
       const response = await Excel2BPAPI.get_template(temp.url);
       this.templates_loading = false;
       downloadFile({data: response}, temp.filename);
     },
   },
 }
</script>
